import { createAction, props } from "@ngrx/store";
import { CardNumbersResponse } from '../../models/response/card-status/CardNumbersResponse';

export const saveEmail = createAction(
  '[Send Email] Save Email',
  props<{ email: string }>()
);

export const saveCardNumbers = createAction(
  '[User Input] Save Driver Card Numbers',
  props<{ response: CardNumbersResponse }>()
);
